// extracted by mini-css-extract-plugin
export default {"hint":"sgQ_YN","close":"IcHKjr"};